import { handleActions } from 'redux-actions';
import { api } from 'api';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { NotificationManager } from "react-notifications";

// ------------------------------------
// Constants
// ------------------------------------
const storeId = 'materia_prima';
const endpoint = 'materia_prima';

const constants = {
    LOADER: `${storeId.toUpperCase()}_LOADER`,
    DATA: `${storeId.toUpperCase()}_DATA`,
    ITEM: `${storeId.toUpperCase()}_ITEM`,
    PAGE: `${storeId.toUpperCase()}_PAGE`,
    ORDERING: `${storeId.toUpperCase()}_ORDERING`,
    SEARCH: `${storeId.toUpperCase()}_SEARCH`,
    ES_PRODUCTO_TERMINADO: `${storeId.toUpperCase()}_ES_PRODUCTO_TERMINADO`,
    MATERIAS_LATEX_CONTAMINADO: `${storeId.toUpperCase()}_MATERIAS_LATEX_CONTAMINADO`,
};

// ------------------------------------
// Initial State
// ------------------------------------
export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    item: {},
    page: 1,
    ordering: '',
    search: '',
    es_producto_terminado: false,
    materias_latex_contaminado: [],
};

// ------------------------------------
// Actions
// ------------------------------------

const setLoader = (loader) => ({
    type: constants.LOADER,
    loader,
});

const setData = (data) => ({
    type: constants.DATA,
    data,
});

const setPage = (page) => ({
    type: constants.PAGE,
    page,
});

const setOrdering = (ordering) => ({
    type: constants.ORDERING,
    ordering,
});

const setSearch = (search) => ({
    type: constants.SEARCH,
    search,
});

const setFiltroProducto = (value) => ({
    type: constants.ES_PRODUCTO_TERMINADO,
    value,
});

// ------------------------------------
// LISTADO PRINCIPAL
// ------------------------------------
const listar = (page = 1) => (dispatch, getStore) => {
    const state = getStore()[storeId];

    const params = {
        page,
        ordering: state.ordering,
        search: state.search,
        es_producto_terminado: state.es_producto_terminado,
    };

    dispatch(setLoader(true));

    api.get(endpoint, params)
        .then((response) => {
            dispatch(setData(response));
            dispatch(setPage(page));
        })
        .catch((error) => {
            console.log(error);
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

// ------------------------------------
// CAMBIO DE FILTRO
// ------------------------------------
const listarPorProductoTerminado = (page = 1, es_producto_terminado = false) => (dispatch) => {
    dispatch(setFiltroProducto(es_producto_terminado));
    dispatch(listar(page));
};

// ------------------------------------
// PAGINACIÓN
// ------------------------------------
const pageChange = (page) => (dispatch) => {
    dispatch(listar(page));
};

// ------------------------------------
// ORDENAMIENTO
// ------------------------------------
const onSortChange = (ordering) => (dispatch, getStore) => {
    const current = getStore()[storeId].ordering;

    const newOrdering = ordering === current ? `-${ordering}` : ordering;

    dispatch(setOrdering(newOrdering));
    dispatch(listar(1));
};

// ------------------------------------
// SEARCH
// ------------------------------------
const searchChange = (search) => (dispatch) => {
    dispatch(setSearch(search));
    dispatch(listar(1));
};

// ------------------------------------
// ENPOINT YA EXISTENTE, SIN CAMBIOS
// ------------------------------------
const getMateriasCoagulo = () => (dispatch) => {
    const params = {};
    params.latex_contaminado = true;
    params.no_paginar = true;

    dispatch(setLoader(true));

    api.get(endpoint, params)
        .then((response) => {
            dispatch({
                type: constants.MATERIAS_LATEX_CONTAMINADO,
                materias_latex_contaminado: response.results,
            });
        })
        .catch(() => {})
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const leer = (id) => (dispatch) => {
    dispatch(setLoader(true));

    api.get(`${endpoint}/${id}`)
        .then((response) => {
            dispatch({
                type: constants.ITEM,
                item: response,
            });

            dispatch(initializeForm("MateriaPrimaForm", response));
        })
        .catch(() => {})
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const crear = (data) => (dispatch) => {
    dispatch(setLoader(true));

    api.post(endpoint, data)
        .then(() => {
            NotificationManager.success('Registro creado', 'Éxito', 3000);

            // 👇 redirección como antes
            dispatch(push('/materias_primas'));
        })
        .catch((error) => {
            if (error && error.detail)
                NotificationManager.error(error.detail, 'ERROR');
            else
                NotificationManager.error('Error en la creación', 'ERROR');
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const editar = (id, data) => (dispatch) => {
    dispatch(setLoader(true));

    api.put(`${endpoint}/${id}`, data)
        .then(() => {
            NotificationManager.success('Registro actualizado', 'Éxito', 3000);

            dispatch(push('/materias_primas'));
        })
        .catch((error) => {
            if (error && error.detail)
                NotificationManager.error(error.detail, 'ERROR');
            else
                NotificationManager.error('Error en la edición', 'ERROR');
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};

const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));

    api.eliminar(`${endpoint}/${id}`)
        .then(() => {
            NotificationManager.success('Registro eliminado', 'Éxito', 3000);

            dispatch(listar()); // 🔥 respeta filtro actual
        })
        .catch(() => {
            NotificationManager.error('Error en la transacción', 'ERROR');
        })
        .finally(() => {
            dispatch(setLoader(false));
        });
};


// ------------------------------------
// Reducer
// ------------------------------------
export const reducers = {
    [constants.LOADER]: (state, { loader }) => ({
        ...state,
        loader,
    }),

    [constants.DATA]: (state, { data }) => ({
        ...state,
        data,
    }),

    [constants.PAGE]: (state, { page }) => ({
        ...state,
        page,
    }),

    [constants.ORDERING]: (state, { ordering }) => ({
        ...state,
        ordering,
    }),

    [constants.SEARCH]: (state, { search }) => ({
        ...state,
        search,
    }),

    [constants.ES_PRODUCTO_TERMINADO]: (state, { value }) => ({
        ...state,
        es_producto_terminado: value,
    }),

    [constants.MATERIAS_LATEX_CONTAMINADO]: (state, { materias_latex_contaminado }) => ({
        ...state,
        materias_latex_contaminado,
    }),

    [constants.ITEM]: (state, { item }) => ({
        ...state,
        item,
    }),
};

export default handleActions(reducers, initialState);

// ------------------------------------
// Export Actions
// ------------------------------------
export const actions = {
    listar,
    listarPorProductoTerminado,
    pageChange,
    onSortChange,
    searchChange,
    getMateriasCoagulo,

    leer,
    crear,
    editar,
    eliminar,
};
